import request from "@/axios";

/** 获取安全策略管理列表的数据 */
export const securityStrategyPage = params => {
  return request({
    url: "/lebo-security/web/securityStrategy/page",
    method: "get",
    params
  });
};

/** 新增安全策略 */
export const securityStrategySave = data => {
  return request({
    url: "/lebo-security/web/securityStrategy/save",
    method: "post",
    data
  });
};

/** 删除安全策略 */
export const securityStrategyRemove = data => {
  return request({
    url: "/lebo-security/web/securityStrategy/remove",
    method: "post",
    params: data
  });
};

/** 编辑安全策略 */
export const securityStrategyUpdate = data => {
  return request({
    url: "/lebo-security/web/securityStrategy/update",
    method: "post",
    data
  });
};

/** 获取安全策略日志 */
export const securityStrategyLog = params => {
  return request({
    url: "/lebo-security/web/securityStrategy/log",
    method: "get",
    params
  });
};

/** 获取模板列表的数据 */
export const ullHitTemplatePage = params => {
  return request({
    url: "/lebo-security/web/fullHitTemplate/page",
    method: "get",
    params
  });
};

/** 获取安全策略详情的数据 */
export const securityStrategyDetail = params => {
  return request({
    url: "/lebo-security/web/securityStrategy/detail",
    method: "get",
    params
  });
};

/** 获取模板详情的数据 */
export const ullHitTemplateDetail = params => {
  return request({
    url: "/lebo-security/web/fullHitTemplate/detail",
    method: "get",
    params
  });
};

/** 新增模板 */
export const fullHitTemplateSave = data => {
  return request({
    url: "/lebo-security/web/fullHitTemplate/save",
    method: "post",
    data
  });
};

/** 修改模板 */
export const fullHitTemplateUpdate = data => {
  return request({
    url: "/lebo-security/web/fullHitTemplate/update",
    method: "post",
    data
  });
};
/** 删除模板 */
export const fullHitTemplateRemove = data => {
  return request({
    url: "/lebo-security/web/fullHitTemplate/remove",
    method: "post",
    params: data
  });
};
